import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class RctCardContent extends Component {
  render() {
    const { children, customClasses, noPadding } = this.props
    return (
      <div className={`${noPadding ? 'rct-full-block' : 'rct-block-content'} ${customClasses || ''}`}>
        {children}
      </div>
    )
  }
}

RctCardContent.defaultProps = {
  children: [],
  customClasses: '',
  noPadding: false,
}

RctCardContent.propTypes = {
  children: PropTypes.any,
  customClasses: PropTypes.string,
  noPadding: PropTypes.bool,
}
